import moment from 'moment-timezone'

const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const countdownFormat = ['Dd Hh', 'H:mm:ss', 'm:ss']

const TIME_FORMAT = 'hh:mm A'

class DateFormatter {
  properFormatForCountdown = date => {
    const ONE_HOUR = 60 * 60 * 1000
    const ONE_DAY = ONE_HOUR * 24
    const dateInMillisec = date.getTime()
    const currDate = new Date()

    if (dateInMillisec >= new Date(currDate.getTime() + ONE_DAY)) {
      return countdownFormat[0]
    } else if (dateInMillisec >= new Date(currDate.getTime() + ONE_HOUR)) {
      return countdownFormat[1]
    }

    return countdownFormat[2]
  }

  generateEventCardTime = eventDate => {
    const eventMoment = moment(eventDate)
    const weekday = eventMoment.format('ddd').toUpperCase()
    const eventDay = eventMoment.date()
    const month = eventMoment.format('MMM').toUpperCase()
    const eventTimezone = this.getCurrentTimeZone()
    const eventTime = this.formatHrMinAMPM(eventDate)
    const eventCardTime = `${weekday} ${eventTime} ${eventTimezone}`

    return { month, eventDay, eventCardTime }
  }

  formatHrMinAMPM = d => moment(d).format('hh:mma')

  getRightDay = dayNum => {
    return days[dayNum]
  }

  convertMth = num => {
    return months[num - 1]
  }

  // JS Date .getMonth() returns 0 to 11 instead of 1 to 12
  getRightMth = monthNum => {
    return monthNum + 1
  }

  getDaySuffix = i => {
    const j = i % 10
    const k = i % 100
    if (j === 1 && k !== 11) {
      return `${i}st`
    }
    if (j === 2 && k !== 12) {
      return `${i}nd`
    }
    if (j === 3 && k !== 13) {
      return `${i}rd`
    }
    return `${i}th`
  }

  addZeroIfNeeded = timeNum => {
    const time = parseInt(timeNum, 10)

    if (timeNum >= 10) {
      return `${timeNum}`
    } else if (timeNum < 10) {
      return `0${time}`
    }
  }

  getAgeFromBirthdate = birthDate =>
    (birthDate &&
      String(Math.max(Math.floor((new Date() - new Date(birthDate).getTime()) / 3.15576e10), 0))) ||
    ''

  convertFrom24Hto12H = timeNum => {
    if (timeNum === 24 || timeNum === 0) {
      return 12
    } else if (timeNum > 12) {
      return timeNum - 12
    } else {
      return timeNum
    }
  }

  returnAMOrPMBasedOnHr = time => {
    if (time >= 0 && time < 12) {
      return 'AM'
    } else if (time >= 12) {
      return 'PM'
    }
  }

  returnDayOfWeek = dateStr => {
    const date = new Date(dateStr)
    const daysOfWeek = [
      'SUNDAY',
      'MONDAY',
      'TUESDAY',
      'WEDNESDAY',
      'THURSDAY',
      'FRIDAY',
      'SATURDAY',
    ]

    return daysOfWeek[date.getDay()]
  }

  returnDayOfWeekNormalCase = dateStr => {
    const date = new Date(dateStr)
    const daysOfWeek = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ]

    return daysOfWeek[date.getDay()]
  }

  returnYYYYMMDD = date => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear()

    if (month.length < 2) month = '0' + month
    if (day.length < 2) day = '0' + day

    return [month, day, year].join('/')
  }

  formatDateForPaymentDate = value => new Date(value).toDateString()

  isBefore24Hours(date) {
    return moment().isBetween(moment(date).subtract(24, 'hours'), moment(date), 'seconds')
  }

  formatStartDate(date) {
    const daysDiff = moment(date).endOf('day').diff(moment().endOf('day'), 'days')

    if (daysDiff === 0 || this.isBefore24Hours(date)) {
      return moment(date).format(TIME_FORMAT)
    } else if (daysDiff === 1) {
      return 'In 1 day'
    } else if (daysDiff > 0 && daysDiff < 7) {
      return `In ${daysDiff} days`
    }

    return new Date(date).toDateString()
  }

  formatEventProfileCountdownDate = totalSeconds => {
    const secondsInDay = 86400
    const secondsInHr = 3600
    const secondsInMin = 60

    if (totalSeconds > 86400) {
      let numOfDaysAway = Math.floor(totalSeconds / secondsInDay)
      return `${numOfDaysAway} days`
    } else if (totalSeconds > 3600) {
      let numOfHrsAway = Math.floor(totalSeconds / secondsInHr)
      return `${numOfHrsAway}h`
    } else if (totalSeconds > 60) {
      let numOfMinAway = Math.floor(totalSeconds / secondsInMin)
      return `${numOfMinAway}m`
    }

    return `${totalSeconds}s`
  }

  isWithinTwoHrPeriod = (d1, d2) => {
    if (
      d1.getFullYear() !== d2.getFullYear() ||
      d1.getMonth() !== d2.getMonth() ||
      d1.getDate() !== d2.getDate()
    ) {
      return false
    }

    if (
      d1.getHours() === d2.getHours() ||
      d1.getHours() + 1 === d2.getHours() ||
      d2.getHours() + 1 === d1.getHours()
    ) {
      return true
    }

    return false
  }

  // Formats the date on event profile page to appropriate format
  formatDateForEventProfile = dateStr => {
    let date = new Date(dateStr)
    return `${this.addZeroIfNeeded(
      this.convertFrom24Hto12H(date.getHours())
    )}:${this.addZeroIfNeeded(date.getMinutes())} ${this.returnAMOrPMBasedOnHr(
      date.getHours()
    )} ${date.getDate()} ${this.convertMth(
      this.getRightMth(date.getMonth())
    )} ${date.getFullYear()}`
  }

  formatDateForDashboard = date => {
    return `${date.getDate()}th ${this.convertMth(
      this.getRightMth(date.getMonth())
    )} ${date.getFullYear()} ${this.addZeroIfNeeded(date.getHours())}:${this.addZeroIfNeeded(
      date.getMinutes()
    )}`
  }

  // Converts serverDate which is in UTC to local time zone, for dashboard page
  convertServerDateToLocalTimeZone = serverDateStr => {
    let userLocalTimezone = this.getLongTimeZone()
    const localDateStr = moment.tz(serverDateStr, userLocalTimezone).format('YYYY/MM/DD HH:mm:ss')
    const localDate = new Date(localDateStr)
    return localDate
  }

  // Functions for event page date & time
  eventPageDate = date => {
    return `${date.getDate()}th ${this.convertMth(
      this.getRightMth(date.getMonth())
    )} ${date.getFullYear()}`
  }

  eventPageTime = date => {
    return `${this.addZeroIfNeeded(date.getHours())}:${this.addZeroIfNeeded(date.getMinutes())}`
  }

  convertEventDateToUTCTimeZone = timeString => {
    const userLocalTimezone = moment.tz.guess()
    const resultTimeStr = moment
      .tz(timeString, 'YYYY-MM-DD HH:mm:ss', userLocalTimezone)
      .utc()
      .format('YYYY-MM-DD HH:mm:ss')

    return resultTimeStr
  }

  /**
   * Get short current timezone.
   */
  getCurrentTimeZone = () => {
    let userLocalTimezone = this.getLongTimeZone()
    if (!userLocalTimezone) {
      return new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]
    }
    return moment().tz(userLocalTimezone).zoneAbbr()
  }

  /**
   * Get long current timezone.
   */
  getLongTimeZone = () => Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || moment.tz.guess()

  getChatDate(date) {
    const dateObj = moment(date)
    const now = moment()

    if (now.isSame(dateObj, 'day')) {
      return dateObj.format(TIME_FORMAT)
    } else if (now.endOf('day').diff(dateObj.clone().endOf('day'), 'days') < 7) {
      return dateObj.format('ddd')
    }

    return dateObj.format('DD/MM/YYYY')
  }
}

const dateFormatter = new DateFormatter()
export default dateFormatter
